module.exports = __webpack_public_path__ + "static/media/stacked-column-chart-new.2e2d7997.png";